import React, { ReactNode, MouseEvent, useState, useRef } from 'react';

import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Tooltip from '@material-ui/core/Tooltip';

import { useStyles } from './Themable.hooks';

import TranslationHelper from '../../helpers/TranslationHelper';
import PopperWrapper from '../PopperWrapper';
interface IOwnProps {
    children: ReactNode;
    iconComponent?: (
        onClick: (e: MouseEvent<HTMLElement>) => void
    ) => ReactNode;
}

const MenuDropdown = ({ children, iconComponent }: IOwnProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const classes = useStyles();

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const popperRef = useRef<HTMLDivElement>(null);

    return (
        <div>
            {iconComponent ? (
                iconComponent(handleClick)
            ) : (
                <Tooltip
                    title={TranslationHelper.translate('Available functions')}
                >
                    <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        className={classes.menuIcon}
                        onClick={handleClick}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
            )}
            <PopperWrapper
                id="long-menu"
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                popperRef={popperRef}
            >
                {children}
            </PopperWrapper>
        </div>
    );
};

export default MenuDropdown;
